import { render } from "./BaseErrorAlerts.vue?vue&type=template&id=2e12394d"
import script from "./BaseErrorAlerts.vue?vue&type=script&lang=js"
export * from "./BaseErrorAlerts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__